import React, { useState, useEffect } from "react";
import { If } from "react-condition";
import RSelect from "react-select";
import { useParams, useLocation } from "react-router-dom";
import axios from "../../services/axios";

function Select({
  data,
  defaultValue,
  isChild,
  hasChiledReadOnly,
  approve,
  editable,
  tokenType,
  errorInputs,
}) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const consultancyName = searchParams.get("consultant_name" || "");

  //Select child -Lovejot(12-DEC-2022)

  const { id, ids, candidateId: cID } = useParams();
  const formId = id;
  const candidateId = ids || cID;
  const [defValue, setDefValue] = useState("");
  const [element, setElement] = useState({
    type: "select",
    properties: {
      label: "Select question field.",
      options: [],
    },
    multiple: false,
    required: false,
  });

  const [value, setValue] = useState("");

  useEffect(() => {
    if (candidateId && isChild) {
      mergeValue();
    }
  }, [isChild, element?.properties, candidateId]);

  //merge value to form template -Lovejot(11-DEC-2022)
  const mergeValue = () => {
    if (isChild) {
      axios
        .get(`/candidates/${candidateId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(tokenType)}`,
          },
        })
        .then((res) => {
          for (let i = 0; i < res.data?.responses?.length; i++) {
            if (res.data?.responses[i].label === element.properties.label) {
              element.properties.value = res.data?.responses[i].value;
              setDefValue(res.data?.responses[i].value);
            }
          }
        });
    }
  };

  useEffect(() => {
    setElement({
      ...element,
      properties: {
        ...element.properties,
        value: defValue,
      },
    });
  }, [defValue]);

  const [readOnly, setReadOnly] = useState(false);

  async function showData() {
    if (data.properties.label === "Select Consultancy Name") {
      data.properties.value = consultancyName ? consultancyName : "";
      setReadOnly(data.properties.value ? true : false);
    } else if (data.properties.label === "Select Job Portal.") {
      setReadOnly(data.properties.value ? true : false);
    }
    setValue(data.properties.value !== null ? data.properties.value : "");
  }

  useEffect(() => {
    showData();
    let obj = { ...data };
    // if (isChild) {
    //   obj.properties.required = true;
    // }
    setElement((prev) => ({ ...prev, ...obj }));
  }, [data, isChild]);

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );

  return (
    <div className="form-group mb-3 col-md-12 form-builder-element">
      <label htmlFor="">
        {element?.properties?.label}
        <If test={element?.properties?.required === true}>
          <span style={{ color: "red" }}>*</span>
        </If>
      </label>

      <div
        className="form-view"
        label={element?.properties?.label}
        data={JSON.stringify(element)}
        value={value ? value : defValue}
      >
        <RSelect
          value={{
            label: value ? value : defValue,
            value: value ? value : defValue,
          }}
          className={`${foundError ? "border border-danger" : ""}`}
          defaultValue={defValue || element.properties.value}
          options={element.properties.options.map((option) => {
            return {
              label: option,
              value: option,
            };
          })}
          onChange={(e) => {
            setValue(e.value);
          }}
          isDisabled={
            (data?.disableField &&
            data?.properties?.value?.length !== 0 &&
            localStorage.getItem("user.role") !== "admin"
              ? data?.disableField
              : readOnly) ||
            (defValue && hasChiledReadOnly) ||
            approve ||
            editable
          }
        ></RSelect>
        {foundError && <p className="text-danger">{foundError?.value}</p>}
      </div>
    </div>
  );
}

export default Select;
